<div #textArea
     id="editable"
     contenteditable="true"
     (input)="onInput($event)"
     (blur)="onBlur()"
     (focus)="onFocus()"
     (paste)="onPaste($event)"
>
</div>
